import GetApi from '../../../common/api/get'

export const FETCH_LP_DATA = "FETCH_LP_DATA"

export const setState = (payload, type = FETCH_LP_DATA) => ({
  type,
  payload
})

export function getData() {
  return (dispatch, getState) => {
    return new GetApi().execute(routeUrlHelper.featureTeleworkPath({ format: 'json' }))
      .then(({ body: properties }) => {
        return dispatch(setState({ properties: properties.filter(prop => prop.self_checkin) }))
      })
      .catch(error => {
        return dispatch(setState({ error }))
      })
  }
}
